import React from 'react';
import { getRolesSelector, getUserSelector, isLoggedInSelector } from '../appContainer/selectors';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

const stateSelector = createStructuredSelector({
  loggedIn: isLoggedInSelector,
  userRoles: getRolesSelector,
  user: getUserSelector,
});

const RenderOnAuthentication = (WrappedComponent, allowedRoles = []) => {
  class WrappedComponentClass extends React.Component {
    render() {
      const { loggedIn, user, userRoles } = this.props;
      const userLoaded = !!Object.keys(user).length && !!Object.keys(userRoles).length;
      const userRole = userRoles[user.role];
      const allowedToSee = allowedRoles.length ? allowedRoles.includes(userRole) : true;

      if (userLoaded && (!loggedIn || !allowedToSee)) {
        return null;
      }

      return <WrappedComponent {...this.props} />;
    }
  }

  return connect(stateSelector)(WrappedComponentClass);
};

export default RenderOnAuthentication;
